// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rut-search[data-v-516824f1]{width:min(100%,360px)}.digitalized-preview[data-v-516824f1]{text-align:center}.digitalized-preview iframe[data-v-516824f1],.digitalized-preview img[data-v-516824f1]{width:100%;height:min(70vh,820px);border:1px solid #d9dee7;-o-object-fit:contain;object-fit:contain;background:#f8f9fa}", ""]);
// Exports
module.exports = exports;
